"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var vec3 = require("@antv/gl-matrix/lib/gl-matrix/vec3");

exports.default = vec3;